
import { Behavior, ChartMetadata, ChartPlugin, t } from '@superset-ui/core';
import buildQuery from '../buildQuery';
import controlPanel from './controlPanel';
import transformProps from './transformProps';
import thumbnail from './images/texture-pie.png';
import { EchartsTexturePieChartProps, EchartsTexturePieFormData } from './types';
 
export default class EchartsBasicTexturePieChartPlugin extends ChartPlugin<
   EchartsTexturePieFormData,
   EchartsTexturePieChartProps
 > {
   constructor() {
     super({
       buildQuery,
       controlPanel,
       loadChart: () => import('./EchartsTexturePie'),
       metadata: new ChartMetadata({
         behaviors: [Behavior.INTERACTIVE_CHART],
         category: t('Part of a Whole'),
         credits: ['https://echarts.apache.org'],
         description:
           t(`The classic. Great for showing how much of a company each investor gets, what demographics follow your blog, or what portion of the budget goes to the military industrial complex.
 
         Pie charts can be difficult to interpret precisely. If clarity of relative proportion is important, consider using a bar or other chart type instead.`),
         exampleGallery: [
           { url: thumbnail },
         ],
         name: t('Texture On Pie Chart'),
         tags: [
           t('Categorical'),
           t('Comparison'),
           t('Popular'),
           t('Proportional'),
           t('ECharts'),
         ],
         thumbnail,
       }),
       transformProps,
     });
   }
}
 